import { isStandardOrder } from '../../utils/order-type-utils';
import { getOrder } from '../order/get-order';
/**
 * Returns the currently reserved seats for a given showtime.
 *
 * @remarks
 * Reserved seats are the seats reserved by the API, and may be different to the currently selected seats.
 */
export const getReservedOrderSeatsForShowtime = (showtimeId) => {
    var _a, _b;
    const order = getOrder();
    if (!isStandardOrder(order))
        return [];
    return (_b = (_a = order.showtimes.find(showtime => showtime.showtimeId === showtimeId)) === null || _a === void 0 ? void 0 : _a.seats) !== null && _b !== void 0 ? _b : [];
};
